import { render, staticRenderFns } from "./NewGlobalVariable.vue?vue&type=template&id=44a336c4"
import script from "./NewGlobalVariable.vue?vue&type=script&lang=js"
export * from "./NewGlobalVariable.vue?vue&type=script&lang=js"
import style0 from "./NewGlobalVariable.vue?vue&type=style&index=0&id=44a336c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports